import { useEffect, useRef } from 'react'

export const useKeydownHandler = (
  handler: (event: KeyboardEvent) => void,
  listenIf = true,
) => {
  const keydownHandlerRef = useRef<((event: KeyboardEvent) => void) | null>(
    null,
  )

  useEffect(() => {
    const cleanUp = () => {
      if (keydownHandlerRef.current) {
        document.removeEventListener('keydown', keydownHandlerRef.current)
      }
    }

    if (listenIf) {
      cleanUp()

      keydownHandlerRef.current = (event) => {
        event.preventDefault()
        event.stopPropagation()

        handler(event)
      }

      document.addEventListener('keydown', keydownHandlerRef.current)
    }

    return cleanUp
  }, [handler, listenIf])
}
